import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';

import {SearchContentConnected as SearchContent} from './SearchContent';

export const Search = () => <RecordsScreen contentComponent={SearchContent} />;
